import { Montserrat } from 'next/font/google';

export const homeMontserrat = Montserrat({
  subsets: ['latin'],
  weight: ['300', '400', '500', '600'],
  display: 'swap',
});

/** For MUI `createTheme` — drawer portals do not inherit `className` from the shell. */
export const HOME_LANDING_FONT_FAMILY = homeMontserrat.style.fontFamily;
